export default [
  { text: "home", url: "/" },
  { text: "products", url: "/products" },
  { text: "about", url: "/about" }
];
